import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * 一覧の左右端に縦いっぱいで置く横スクロールボタン。
 *
 * ngtg_msc の `_ScrollEdgeButton` に対応する。カードの外側、画面の左右余白
 * （24px）にちょうど収まる幅にしてある。msc に合わせて常時表示し、その向きへ
 * スクロールできないときだけ薄くする。
 *
 * 一覧画面のルート要素を `relative` にして、その中に置くこと。
 */
export default function EdgeScrollButton({
  side,
  isDisabled,
  onPress,
}: {
  side: "left" | "right";
  isDisabled: boolean;
  onPress: () => void;
}) {
  const isLeft = side === "left";
  return (
    <button
      type="button"
      aria-label={isLeft ? "左へスクロール" : "右へスクロール"}
      disabled={isDisabled}
      onClick={onPress}
      className={[
        "absolute inset-y-0 flex w-6 cursor-pointer items-center justify-center text-brand-500 transition-colors",
        // Flutter 側は Colors.grey の alpha 0.1。
        "bg-[rgba(158,158,158,0.1)] hover:bg-[rgba(158,158,158,0.2)]",
        "disabled:cursor-default disabled:text-default-300 disabled:hover:bg-[rgba(158,158,158,0.1)]",
        isLeft ? "left-0" : "right-0",
      ].join(" ")}
    >
      {isLeft ? <ChevronLeft size={24} /> : <ChevronRight size={24} />}
    </button>
  );
}
